var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPharmacy = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.44 8.13-3.85-3.84a4.45 4.45 0 0 0-6.3 6.3l3.85 3.85Zm5.26 5.26-3.84-3.84-6.31 6.3 3.85 3.85a4.46 4.46 0 1 0 6.3-6.31Z"
})));
export default SvgPharmacy;